export default {"src":"/_next/static/media/Edit.e40dc149.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};